import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import i18n from "@/config/i18n";
import { piThConvertStringToTimes } from "@/utils/time.helper";
let PiFeeDetailsChildRateTable = class PiFeeDetailsChildRateTable extends Vue {
    constructor() {
        super(...arguments);
        this.slotFlagTextAC = [
            i18n.t("commonTableName.jian"),
            i18n.t("commonTableName.feng"),
            i18n.t("commonTableName.ping"),
            i18n.t("commonTableName.gu"),
        ];
        this.tableColumns = [];
    }
    getTableColumns(type) {
        let text = type == "dc"
            ? i18n.t("chargeFeeManage.dcRateDetails")
            : i18n.t("chargeFeeManage.acRateDetails");
        return [
            {
                title: text,
                align: "center",
                children: [
                    {
                        title: i18n.t("commonTableName.time"),
                        key: "time",
                        slot: "time",
                        minWidth: 180,
                    },
                    {
                        title: i18n.t("commonTableName.slotFlag"),
                        key: "slotFlag",
                        minWidth: 100,
                        slot: "slotFlag",
                    },
                    {
                        title: i18n.t("commonTableName.elecPrice"),
                        key: "slotElecPrice",
                        minWidth: 100,
                        ...this.$config.tablePrice,
                    },
                    {
                        title: i18n.t("commonTableName.servicePrice"),
                        key: "slotServicePrice",
                        minWidth: 100,
                        ...this.$config.tablePrice,
                    },
                ],
            },
        ];
    }
    getTime(row) {
        if (row.time) {
            // 已经转过的直接显示
            return typeof row.time == "object" ? row.time.join(",") : row.time;
        }
        else {
            return (piThConvertStringToTimes(row.beginTime) +
                "-" +
                piThConvertStringToTimes(row.endTime));
        }
    }
};
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiFeeDetailsChildRateTable.prototype, "acTableList", void 0);
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiFeeDetailsChildRateTable.prototype, "dcTableList", void 0);
__decorate([
    Prop({ default: "" })
], PiFeeDetailsChildRateTable.prototype, "cardTitle", void 0);
__decorate([
    Prop({ default: "" })
], PiFeeDetailsChildRateTable.prototype, "titleSize", void 0);
__decorate([
    Prop({ default: "line" })
], PiFeeDetailsChildRateTable.prototype, "cardTitleIcon", void 0);
__decorate([
    Prop({ default: false })
], PiFeeDetailsChildRateTable.prototype, "loading", void 0);
PiFeeDetailsChildRateTable = __decorate([
    Component({
        components: {},
    })
], PiFeeDetailsChildRateTable);
export default PiFeeDetailsChildRateTable;
